.bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Figma spec: padding 12 vertical / 16 horizontal. */
  padding: var(--spacing-12) var(--spacing-16);
  /* Bottom border using the semantic stroke token — auto-swaps light
   * (#e5e5e5) / dark (#404040), matching the Figma neutral border. */
  border-bottom: 1px solid var(--stroke-neutral);
  background: var(--bg-primary);
  width: 100%;
  box-sizing: border-box;
  /* Fixed chrome, same rule as BottomNavBar: a tall scrolling sibling must
   * not be able to compress the header. */
  flex: none;
  /* Width is fluid, NOT the Figma-fixed 360px — the popup, side panel,
   * and web shell each control their own widths via the entry-point
   * CSS, so the header should fill its parent. */
}

.left {
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
  /* Allow the device name to truncate inside this flex item rather
   * than overflowing the bar — min-width:0 unlocks shrinking. */
  min-width: 0;
  flex: 1 1 auto;
}

/* Connection status wrapper: a role="status" region (which is an
 * implicit polite live region per the ARIA spec — no separate
 * aria-live attribute needed) that contains the visual StatusDot
 * AND a sr-only sibling carrying the announcement text. The
 * text-content change (when sseConnected flips) triggers the live
 * region announcement; the StatusDot itself is decorative
 * (aria-hidden). Display contents avoids adding an extra layout
 * box around the dot. */
.connectionStatus {
  display: contents;
}

/* Standard sr-only utility: visually hidden but kept in the
 * accessibility tree so screen readers can announce it. Inlined
 * here rather than promoted to a global utility because HeaderBar
 * is currently the only consumer; if a second consumer appears,
 * extract to a shared layer. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.deviceName {
  font: var(--text-subtitle-semibold);
  color: var(--text-primary);
  /* Truncate long device names with an ellipsis. min-width:0 on the
   * parent .left flex item unlocks this — the title attribute on the
   * <span> reveals the full name on hover. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Trailing cluster: hosts the optional `trailing` slot (e.g.
 * PublicModeToggle) plus the settings IconButton. flex-shrink:0 so
 * the right cluster never shrinks below its contents — the device
 * name on the left is the truncating element. */
.trailing {
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  flex-shrink: 0;
}
